var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.dataLoading),expression:"dataLoading"}],staticClass:"alert-detail-wrapper"},[(_vm.detailsData)?_c('div',{staticClass:"alert-detail"},[_c('details-component',{attrs:{"details-condition":_vm.detailCondition}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }